import { put, takeEvery, select } from 'redux-saga/effects';

import * as interventionActions from 'modules/interventions/actions/core';
import { getSelectedInterventionId } from 'modules/interventions/selectors';
import { getSelectedInterventionMode } from 'modules/interventions/selectors/details';
import { createNotification } from 'modules/toast-notifications/actions';

import * as Utils from './utils/error.utils';

/** @param {import("modules/global/generic.types").ErrorAction} action */
function* interventionErrorWorker({ type, payload: error, meta }) {
  const interventionId = yield select(getSelectedInterventionId);

  const errorType = Utils.isCustomError(error?.response?.status)
    ? Utils.getErrorType(error.response.data?.errorMessage)
    : 'default';

  const notificationProps = Utils.ERRORS_MESSAGES[type]?.[errorType] ??
    Utils.ERRORS_MESSAGES[type]?.default ?? {
    message: {
      id: 'http.error.message',
      defaultMessage: 'Oops! Something went wrong.',
    },
  };

  if (interventionId && notificationProps.refresh) {
    const mode = yield select(getSelectedInterventionMode);
    notificationProps.btn = {
      onClick: store => {
        store.dispatch(interventionActions.fetchIntervention(interventionId, mode, meta));
      },
      size: 'small',
      type: 'primary',
    };
  }

  yield put(createNotification({ type: 'error', ...notificationProps }));
}

const interventionErrorChannel = ({ type }) => Object.keys(Utils.ERRORS_MESSAGES).includes(type);

export default function* interventionsErrorSagas() {
  yield takeEvery(interventionErrorChannel, interventionErrorWorker);
}
